/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';
import type { GoldenRecord } from './GoldenRecord';
import {
    GoldenRecordFromJSON,
    GoldenRecordFromJSONTyped,
    GoldenRecordToJSON,
    GoldenRecordToJSONTyped,
} from './GoldenRecord';

/**
 * 
 * @export
 * @interface GoldenRecordResponse
 */
export interface GoldenRecordResponse {
    /**
     * 
     * @type {boolean}
     * @memberof GoldenRecordResponse
     */
    success?: boolean;
    /**
     * 
     * @type {GoldenRecord}
     * @memberof GoldenRecordResponse
     */
    data?: GoldenRecord;
    /**
     * 
     * @type {string}
     * @memberof GoldenRecordResponse
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof GoldenRecordResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof GoldenRecordResponse
     */
    userTimezone?: string;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof GoldenRecordResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof GoldenRecordResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the GoldenRecordResponse interface.
 */
export function instanceOfGoldenRecordResponse(value: object): value is GoldenRecordResponse {
    return true;
}

export function GoldenRecordResponseFromJSON(json: any): GoldenRecordResponse {
    return GoldenRecordResponseFromJSONTyped(json, false);
}

export function GoldenRecordResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoldenRecordResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'data': json['data'] == null ? undefined : GoldenRecordFromJSON(json['data']),
        'message': json['message'] == null ? undefined : json['message'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function GoldenRecordResponseToJSON(json: any): GoldenRecordResponse {
    return GoldenRecordResponseToJSONTyped(json, false);
}

export function GoldenRecordResponseToJSONTyped(value?: GoldenRecordResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'data': GoldenRecordToJSON(value['data']),
        'message': value['message'],
        'errorMessage': value['errorMessage'],
        'userTimezone': value['userTimezone'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

